import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getSoftwareById } from '../data/softwareData';

const SoftwareDetail = () => {
  const { id } = useParams();
  const software = getSoftwareById(id);

  if (!software) {
    return (
      <div className="software-detail">
        <div className="not-found">
          <h2>软件未找到</h2>
          <Link to="/" className="back-home-btn">返回首页</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="software-detail">
      <div className="detail-header">
        <Link to="/" className="back-home-btn">
          ← 返回首页
        </Link>
        <h1>{software.name}</h1>
      </div>

      <div className="detail-content">
        <div className="software-info">
          <div className="software-header">
            <div className="detail-icon">{software.icon}</div>
            <div>
              <h2>{software.name}</h2>
              <span className="detail-category">{software.category}</span>
            </div>
          </div>

          <div className="description-section">
            <h3>软件介绍</h3>
            <p>{software.description}</p>
          </div>

          <div className="screenshots-section">
            <h3>软件截图</h3>
            <div className="screenshots-grid">
              {software.screenshots.map((screenshot, index) => (
                <div key={index} className="screenshot-item">
                  <img 
                    src={screenshot} 
                    alt={`${software.name} 截图 ${index + 1}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/600x400/CCCCCC/333333?text=截图加载失败";
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="download-section">
            <h3>下载地址</h3>
            <div className="download-links">
              {software.downloadLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-link"
                >
                  {link.name}
                </a>
              ))}
            </div>
            <p className="download-note">
              ⚠️ 提示：建议从官方渠道下载，确保软件安全无毒
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoftwareDetail;